import styled, { css } from 'styled-components'
import { rem } from 'utils/common'
import { device, merchantThemes } from 'components/Variable'

export const ReclamationContactFormElem = styled.form``
export const ReclamationContactFormBody = styled.div`
	padding: ${rem(35, 35)};
	&.modal {
		text-align: center;
	}
	&.modal_policy,
	&.modal_faq,
	&.modal_shipping,
	&.modal_terms {
		text-align: left;
	}
	@media (${device.mobileL}) {
		padding: ${rem(20)};
	}
`
export const ReclamationContactFormClose = styled.div`
	position: absolute;
	cursor: pointer;
	top: 50%;
	margin: ${rem(-11)} ${rem(2)} 0 0;
	right: ${rem(8)};
	border: ${rem(1)} solid ${({ theme }) => theme.color.grayTen};
	padding: ${rem(4)};
`
export const ReclamationContactFormHeader = styled.div`
	position: relative;
	background: ${({ theme }) => theme.color.grayFive};
	text-align: center;
	padding: ${rem(10)};

	${(p) =>
		p.theme.name === merchantThemes.toteme &&
		css`
			background: transparent;
			border-bottom: ${rem(1)} solid ${({ theme }) => theme.color.primary};
		`}
`
export const ReclamationContactFormTitle = styled.div`
	text-transform: uppercase;
	font-size: ${rem(15)};
	font-weight: 600;
	overflow: hidden;
	text-overflow: ellipsis;
	padding: ${rem(0, 22, 0, 0)};

	${(p) =>
		p.theme.name === merchantThemes.toteme &&
		css`
			font-weight: normal;
			text-transform: none;
		`}

	&.modal {
		font-size: ${rem(17)};
	}

	@media (${device.mobileXL}) {
		font-size: ${rem(13)};
	}
`
export const ReclamationContactFormSubTitle = styled.div`
	font-size: ${rem(14)};
	text-align: center;
	color: ${({ theme }) => theme.color.grayTen};
	margin-bottom: ${rem(20)};
`
export const ReclamationContactFormTextArea = styled.textarea`
	border: ${rem(1)} solid ${({ theme }) => theme.color.blackOne};
	background: ${({ theme }) => theme.color.grayFive};
	min-height: ${rem(120)};
	border-radius: ${rem(3)};
	margin-bottom: ${rem(40)};
	padding: ${rem(10)};
	font-size: ${rem(16)};
	font-family: Arial;
	display: block;
	width: 100%;
	resize: none;

	${(p) =>
		p.theme.name === merchantThemes.toteme &&
		css`
			background: ${({ theme }) => theme.color.primary};
			border-radius: ${rem(10)};
			font-size: ${rem(10)};
		`}
`
export const ReclamationControlWrapper = styled.div`
	margin-top: ${rem(25)};
`
